import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksBudgetImpactBreakdowns.BudgetAmountsInfo', {
    period: 'Period',
    budget: 'Budget',
    remaining: 'Remaining',
    bills: 'Bills',
    purchaseOrders: 'Purchase Orders',
    expenses: 'Expenses',
    approved: 'Approved',
    onApproval: 'On approval',
    onReview: 'On review',
    note: 'Please note: all amounts do not include the amount of the current {requestFriendlyName}.',
});
